/**
 * 취급부서 호환 변환
 *
 * 2026-09-09 "MSDS 개선안" 이전 문서는 공장명·공정명을 body 최상위 단일 값으로,
 * 사업장은 stdInfo.field_name 으로 저장했다. 개선안 이후에는 body.취급부서 배열
 * (행마다 사업장/공장명/공정명)로 바뀌었고, 화면과 현황 목록은 이 배열만 읽는다.
 *
 * 예전 문서를 그대로 열면 취급부서가 비어 보이므로, 불러올 때 예전 값을
 * 취급부서 한 행으로 변환해 준다. 추가 API 호출 없이 이미 받은 body 만 사용한다.
 */
export function getHandlingDepts(body) {
  if (!body) return [];

  const 취급부서 = Array.isArray(body.취급부서) ? body.취급부서 : [];
  if (취급부서.length > 0) return 취급부서;

  const 사업장 = (body.stdInfo && body.stdInfo.field_name) || "";
  const 공장명 = body.공장명 || "";
  const 공정명 = body.공정명 || "";
  if (!공장명 && !공정명) return [];

  return [{ is_checked: false, 사업장, 공장명, 공정명 }];
}
